import { useEffect } from "react";

const REFERRAL_STORAGE_KEY = "bitzo_referral_code";
const REFERRAL_EXPIRY_DAYS = 90;

export function persistReferralCode(): void {
  if (typeof window === "undefined") return;
  
  const params = new URLSearchParams(window.location.search);
  const refCode = params.get("ref");
  if (!refCode || !refCode.trim()) return;

  // First-click wins: don't overwrite an existing, unexpired referral. (getReferralCode
  // returns null and clears storage once the 90-day window has passed, so a fresh click
  // after expiry is still captured.)
  if (getReferralCode()) return;

  const code = refCode.trim().toUpperCase();
  const data = {
    code,
    capturedAt: Date.now(),
    expiresAt: Date.now() + REFERRAL_EXPIRY_DAYS * 24 * 60 * 60 * 1000,
    landingUrl: window.location.href,
  };
  localStorage.setItem(REFERRAL_STORAGE_KEY, JSON.stringify(data));
  document.cookie = `bitzo_ref=${code}; path=/; max-age=${REFERRAL_EXPIRY_DAYS * 24 * 60 * 60}; SameSite=Lax; Secure`;
}

export function getReferralCode(): string | null {
  if (typeof window === "undefined") return null;
  
  try {
    const stored = localStorage.getItem(REFERRAL_STORAGE_KEY);
    if (!stored) return null;
    
    const data = JSON.parse(stored);
    if (data.expiresAt && Date.now() > data.expiresAt) {
      localStorage.removeItem(REFERRAL_STORAGE_KEY);
      return null;
    }
    
    return data.code || null;
  } catch {
    return null;
  }
}

export function clearReferralCode(): void {
  if (typeof window === "undefined") return;
  localStorage.removeItem(REFERRAL_STORAGE_KEY);
  document.cookie = "bitzo_ref=; path=/; max-age=0";
}

export function useReferralCode(): void {
  useEffect(() => {
    persistReferralCode();
  }, []);
}

export default useReferralCode;
